import React from 'react'
import clsx from 'clsx'
import { subDays, addDays, isEqual, isSameMonth } from 'date-fns'

import { CalendarProps } from './Calendar'
import format from 'libs/dateFns/format'
import { DATE } from 'helpers/constants'

export interface DateCalendarProps
  extends Required<Pick<CalendarProps, 'disabledDate' | 'value'>> {
  displayDate: Date
  onChange: (value: Date) => void
}

const DateCalendar: React.FC<DateCalendarProps> = ({
  value,
  displayDate,
  onChange,
  disabledDate,
}: DateCalendarProps): JSX.Element => {
  const base = 'calendar'
  const weekSize = 7
  const calendarSize = weekSize * 6

  const getFirstDate = (date: Date): Date => {
    const firstDate = subDays(date, date.getDate())

    return subDays(firstDate, firstDate.getDay())
  }

  const dates: Date[] = Array(calendarSize)
    .fill(getFirstDate(displayDate))
    .map((date, incrementor) => addDays(date, incrementor))

  const datesForTitle = Array(weekSize)
    .fill(getFirstDate(displayDate))
    .map((date, incrementor) => addDays(date, incrementor))

  const itemCn = (date: Date) =>
    clsx(
      `${base}__calendar-item`,
      `${base}__calendar-item--day`,
      value && isEqual(value, date) && `${base}__calendar-item--selected`,
      !isSameMonth(displayDate, date) && `${base}__calendar-item--edge`,
      disabledDate(date) && `${base}__calendar-item--disabled`,
    )

  return (
    <div
      className={`${base}__calendar-body--day`}
      data-testid='calendar-container-day'
    >
      {datesForTitle.map((dateForTitle, index) => (
        <div key={index} className={`${base}__calendar-item`}>
          {format(dateForTitle, 'EEEEEE')}
        </div>
      ))}
      {dates.map((_date, index) => (
        <div
          key={index}
          className={itemCn(_date)}
          data-testid={`calendar-day-${format(_date, DATE.QUERY)}`}
          {...(!disabledDate(_date) && { onClick: () => onChange(_date) })}
        >
          {_date.getDate()}
        </div>
      ))}
    </div>
  )
}

export default DateCalendar
